import React from 'react';

const Refunds = (props) => {
  return (
    <div className='main'>
      <br/>
      <h1 className='terms-heading'>
        Refund Policy
      </h1> <br/>

      <h6 className='terms-heading'>
        Last updated: April 17, 2023
      </h6> <br/>

      <br/>
      <h5 className='terms-heading'>
      Refund Policy
      </h5> <br/>
      <p1 className='terms-text'>
      Thanks for being a patron with WizWack. If you are not entirely satisfied with your subscription, we are here to help.
      </p1><br/><br/>


      <br/>
      <h5 className='terms-heading'>
      Refund
      </h5> <br/>
      <p1 className='terms-text'>
      Once we receive your Refund request, we will inspect it and notify you on the status of your refund.
      </p1><br/><br/>
      <p1 className='terms-text'>
      If your refund request is approved, we will initiate a refund to your credit card (or original method of payment) within 7 working days. You will receive the credit within a certain amount of days, depending on your card issuer's policies.
      </p1><br/><br/>
      <p1 className='terms-text'>
      In case of unforeseen technical glitch, WizWack would refund subscription upon reviewing the complaint. Final decision lies with the company.
      </p1><br/><br/>
      <p1 className='terms-text'>
      To initiate a refund, submit a request using the contact us section sharing all the details.
      </p1><br/><br/>
    </div>
  );
}

export default Refunds